// src/utils/i18n.js
// Looks up UI strings from the active-locale JSON injected by PHP (ercData.strings).
// Content coming from the API itself (brand/model/engine names, etc.) is never
// routed through here — only static UI labels/titles are translatable.
export function t(key, fallback = null) {
  const strings = window.ercData?.strings;
  if (strings && Object.prototype.hasOwnProperty.call(strings, key)) {
    return strings[key];
  }
  return fallback !== null ? fallback : key;
}

// Vehicle type names come from the API untranslated (e.g. "Cars & LCV") and the
// API has no locale support. This finite, stable list is translated client-side;
// anything not in the map (future new types) falls back to the raw API value.
const VEHICLE_TYPE_KEYS = {
  'cars & lcv': 'vehicleType.carsLcv',
  'trucks & buses': 'vehicleType.trucksBuses',
  'agriculture': 'vehicleType.agriculture',
  'marine': 'vehicleType.marine',
  'motorcycles & atvs': 'vehicleType.motorcyclesAtvs',
  'heavy machinery': 'vehicleType.heavyMachinery',
};

export function translateVehicleTypeName(name) {
  if (typeof name !== 'string') return name;
  const key = VEHICLE_TYPE_KEYS[name.trim().toLowerCase()];
  return key ? t(key, name) : name;
}
